import React, { Component } from "react";

export default class DecorationsSubMenu extends Component {
  render() {
    return (
      <ul className="second-child-body active">
        {Object.keys(this.props.decorations).map((decorationKey, i) => (
          <li
            className={
              this.props.activeDecorationType === decorationKey
                ? "second-child active"
                : "second-child"
            }
            id={decorationKey}
            onClick={this.props.activeDecorationTypeHandler}
            key={decorationKey + i}
          >
            <span>{decorationKey}</span>
          </li>
        ))}
      </ul>
    );
  }
}
